import React, { Component } from 'react';
import config, { currentCountryCode } from '../../config';
import { HTMLTrans } from '../Common/Translations';
import ConnectWithFacebook from './ConnectWithFacebook';
import ConnectWithGoogle from './ConnectWithGoogle';
import ChangePasswordButton from '../Auth/ChangePassword';
import { connectBackendConfig } from '../Common/connectBackendConfig'
import { compose } from 'recompose';

class PersonalInfo extends Component {
    constructor(props) {
        super(props);

        this.state = {
            user: {},
        };

        this._updatePersonalInfo = this._updatePersonalInfo.bind(this);
        this._handleInputChange = this._handleInputChange.bind(this);
    }

    _updatePersonalInfo(event) {
        event.preventDefault();

        const data = {
            first_name: this.state.user.first_name,
            last_name: this.state.user.last_name,
            gender: this.state.user.gender || 'male',
            dob: this.state.user.dob,
        };

        if (currentCountryCode.toUpperCase() === 'MY') {
            data.bcard_number = this.state.user.bcard_number;
        }

        this.props.updatePersonalInfo(data);
    }

    _handleInputChange(event) {
        const { user } = this.state;
        user[event.target.name] = event.target.value;

        this.setState({ user });
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            user: nextProps.user,
        });
    }

    render() {
        let user = this.state.user;
        let isValid =
            !!user.first_name &&
            !!user.last_name &&
            !!user.dob &&
            !!user.email;
        let styles = { color: 'red' };

        const {
            backendConfig: {
                facebookIntegrationEnabled = false
            } = {},
        } = this.props;

        return (
            <div>
                <div className="dashboard-card mb-3">
                    <h3><HTMLTrans id="account.personalinfo_title">Account Information</HTMLTrans></h3>
                    <form onSubmit={this._updatePersonalInfo}>
                        <hr/>
                        <div className="row my-4">
                            <div className="col-md-6">
                                <b><label htmlFor="first_name"><HTMLTrans id="account.personalinfo_firstname_label">First name</HTMLTrans><span style={styles}>*</span></label></b>
                                <input name="first_name"
                                    type="text"
                                    id="first_name"
                                    className="form-control"
                                    required
                                    maxLength="30"
                                    onChange={this._handleInputChange}
                                    value={user.first_name || ''}
                                />
                            </div>
                            <div className="col-md-6">
                                <b><label htmlFor="last_name"><HTMLTrans id="account.personalinfo_lastname_label">Last name</HTMLTrans><span style={styles}>*</span></label></b>
                                <input name="last_name"
                                    type="text"
                                    id="last_name"
                                    className="form-control"
                                    required
                                    maxLength="30"
                                    onChange={this._handleInputChange}
                                    value={user.last_name || ''}
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6">
                                <b><label htmlFor="gender"><HTMLTrans id="account.personalinfo_gender_label">Gender</HTMLTrans></label></b>
                                <div className="form-group">
                                    <select className="form-control" id="genderSelect" name="gender" onChange={this._handleInputChange} value={user.gender || 'male'}>
                                        <option value="male">{this.props.t("account.personalinfo_gender_male", "Male")}</option>
                                        <option value="female">{this.props.t("account.personalinfo_gender_female", "Female")}</option>
                                    </select>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <b><label className="ml-1"><HTMLTrans id="account.personalinfo_dob_label">Date of birth</HTMLTrans></label></b>
                                <div className="row">
                                    <div className='col-12'>
                                        <input name="dob" 
                                            type="date"
                                            required
                                            value={user.dob || ''}
                                            id="dob"
                                            onChange={this._handleInputChange}
                                            className={!!user.dob ? 'form-control' : 'form-control is-invalid'}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-6">
                                <b><label htmlFor="email"><HTMLTrans id="account.personalinfo_username_label">Username / Email</HTMLTrans></label></b>
                                <input name="email"
                                    type="email"
                                    id="email"
                                    className="form-control"
                                    value={user.email || ''}
                                    readOnly={true} />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6 mt-3 mb-3" id="submit-button-div">
                                {isValid 
                                    ?<input id="personal-info-submit" className="btn btn-lg btn-primary px-7" type="submit" value="Save" />
                                    :<button className="btn btn-primary px-7" disabled><HTMLTrans id="account.personalinfo_button_save">Save</HTMLTrans></button>
                                }
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-6" style={styles}>* <HTMLTrans id="account.personalinfo_required">Required Fields</HTMLTrans></div>
                        </div>
                    </form>
                </div>
                <div className="dashboard-card mb-3">
                    <h3>Social Media</h3>
                    <hr/>
                    <div className="row">
                        {facebookIntegrationEnabled && <ConnectWithFacebook/>}
                        <ConnectWithGoogle/>
                    </div>
                </div>
                <div className="dashboard-card mb-3">
                <h3><HTMLTrans id="account.personalinfo_changepassword">Change Password</HTMLTrans>
                </h3>
                <hr/>
                <div className="row col-md-auto mb-3">
                    <ChangePasswordButton/>
                </div>
                </div>
            </div>
        )
    }
}

const enhance = compose(
    connectBackendConfig
)

export default enhance(PersonalInfo);
export const undecorated = PersonalInfo;


// WEBPACK FOOTER //
// ./src/Account/PersonalInfo.js